import { Reducer } from 'redux'
import { initialProfileState } from './initialState'
import { LOGIN, LOGINTOKEN, LOGOUT, ProfileActionTypes, ProfileState, SET_LOGIN_MODAL } from './types'

const reducer: Reducer<ProfileState, ProfileActionTypes> = (state: ProfileState = initialProfileState, action: ProfileActionTypes) => {
	switch (action.type) {
		case LOGINTOKEN:
		case LOGIN: {
			return {
				...state,
				...action.payload,
				location: window.location.pathname
			}
		}
		case LOGOUT: {
			return {
				...state,
				...{ authenticated: false }
			}
		}
		case SET_LOGIN_MODAL: {
			const LoginModalState = action.payload
			return {
				...state,
				...LoginModalState
			}
		}
		default: {
			return state
		}
	}
}

export { reducer as profileReducer }
